import { version, component_id } from './package.json'

export default {
  version,
  component_id,
  dependencies: [
    {
      type: 'container',
      version: '1.3.2',
      component_id: 4,
    }
  ],
  display: false,
  style: {
    position: 'fixed',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    'zIndex': 100
  },
  items: [],
};
